import React, { createContext } from "react";
import "./App.css";
import { NavigateSetter } from "./utils/NavigationHistoryUtils";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { CabinetLayout } from "./layouts/index";
import {
  Error,
  Forms,
  FormsSUITT,
  OrgStructure,
  Login,
  Logout,
  Main,
  Register,
  Support,
  User,
  UserEdit,
  Users,
  UserWorkAdd,
} from "./pages";
import { getUserToken } from "./utils/index";
import auth from "./store/auth";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { mainTheme } from "./theme/index";
import { SnackbarUtilsConfigurator } from "./utils/SnackBarUtils";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

process.env.CI = false;

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated
const ProtectedRoute = ({ children }) => {
  const userToken = getUserToken();
  if (!userToken) return <Navigate to="/login" replace />;

  return children;
};

const store = {
  auth,
};

export const StoreContext = createContext();

export const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <SnackbarProvider maxSnack={3}>
        <SnackbarUtilsConfigurator />
        <StoreContext.Provider value={store}>
          <ThemeProvider theme={mainTheme}>
            <CssBaseline />
            <Router>
              <NavigateSetter />
              <Routes>
                <Route path="/" element={<CabinetLayout />}>
                  <Route index element={<Login />} />
                  <Route path={"/login"} element={<Login />} />
                  <Route path={"/register"} element={<Register />} />
                  <Route path={"/logout"} element={<Logout />} />
                  <Route path={"/contact"} element={<Support />} />
                </Route>

                <Route
                  path="/cabinet/"
                  element={
                    <ProtectedRoute>
                      <CabinetLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Main />} />
                  <Route path={"users"} element={<Users />} />
                  <Route path={"users/:id"} element={<User />} />
                  <Route
                    path={"users/:id/work/add"}
                    element={<UserWorkAdd />}
                  />
                  <Route path={"users/:id/edit"} element={<UserEdit />} />
                  <Route path={"forms"} element={<Forms />} />
                  <Route path={"forms/suitt"} element={<FormsSUITT />} />
                  <Route path={"org-structure"} element={<OrgStructure />} />
                </Route>

                <Route path="*" element={<Error />} />
              </Routes>
            </Router>
          </ThemeProvider>
        </StoreContext.Provider>
      </SnackbarProvider>
    </LocalizationProvider>
  );
};

console.log(
  "%c eforms SUITT",
  "font-weight: bold; font-size: 72px;color: #00ffff; text-shadow: 3px 3px 0 #00ECEC, 6px 6px 0 #80FFFF, 9px 9px 0 #070649, 12px 12px 0 #070649, 15px 15px 0 #070649, 18px 18px 0 #070649, 21px 21px 0 #070649"
);
